import React from "react"

import LocationItem from "./location-item"
import styled from "styled-components"
import { setRem, media, setColor } from "../../style"

import Container from '@material-ui/core/Container';
import { FormattedMessage } from "gatsby-plugin-intl"



const LocationDeals = ( { destinations } ) => {

  return (
    <Contain maxWidth="lg">
      <div>
        <h2><FormattedMessage id="deals.locationDeals.ourTopDestinations" /></h2>
        <div className="titleUnderline" />
      </div>
    
      <DealsCenter>
        
        {destinations.map(deal => (
          
          <LocationItem key={deal.id} deal={deal} />
        ))}
      </DealsCenter>
    </Contain>
  )
}

export default LocationDeals

const Contain = styled(Container) `
  margin-top: ${setRem(15)};
  font-size: 1.2rem;
  h2 {
    margin-top: 25px;
    color: ${setColor.secondaryColor};
    font-weight: bold;
    font-size: ${setRem(32)};
    text-align: center;
  }
  .titleUnderline {
    border: 1px solid ${setColor.primaryColor};
    margin: 5px auto 35px;
    width: 25%;
    
  }
`

const DealsCenter = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  ${media.tablet`
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: ${setRem(32)};
      

    `}

  ${media.large`
    grid-template-columns: repeat(3,1fr);
    justify-items: center;
    `}
`
